import { useState, useEffect } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { supabase } from '../supabase'

function ResetPassword() {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [cargando, setCargando] = useState(false)
  const [error, setError] = useState('')
  const [listo, setListo] = useState(false)
  const [sesionLista, setSesionLista] = useState(false)
  const [verPassword, setVerPassword] = useState(false)
  const [verConfirm, setVerConfirm] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    if (code) {
      supabase.auth.exchangeCodeForSession(code)
        .then(({ data, error }) => {
          console.log('Exchange result:', data, error)
          if (error) setError('Enlace inválido o expirado.')
          else setSesionLista(true)
        })
    } else {
      setError('Enlace inválido o expirado.')
    }
  }, [])

  async function handleReset(e) {
    e.preventDefault()
    const { data: { session } } = await supabase.auth.getSession()
    console.log('Sesión al guardar:', session?.user?.email)
    if (!session) {
      setError('Sesión expirada. Solicita un nuevo link de recuperación.')
      return
    }
    console.log('Password a cambiar:', password)
    if (password !== confirmPassword) { setError('Las contraseñas no coinciden.'); return }
    if (password.length < 8) { setError('La contraseña debe tener al menos 8 caracteres.'); return }
    setCargando(true)
    setError('')
    const { error } = await supabase.auth.updateUser({ password })
    if (error) {
      console.error('Error reset:', error)
      setError('Error: ' + error.message)
      setCargando(false)
      return
    }
    setListo(true)
    setCargando(false)
    await supabase.auth.signOut()
  }

  return (
    <div style={estilos.pagina}>
      <div style={estilos.contenido}>
        <div style={estilos.caja}>
          <img src="/logo-circulo.png" alt="ETERN-ME" style={estilos.logo} />
          {listo ? (
            <>
              <h2 style={estilos.titulo}>¡Contraseña actualizada!</h2>
              <p style={estilos.subtitulo}>Ya puedes iniciar sesión con tu nueva contraseña.</p>
              <button onClick={() => window.location.href = '/'} style={estilos.btn}>
                Ir a iniciar sesión
              </button>
            </>
          ) : (
            <>
              <h2 style={estilos.titulo}>Nueva contraseña</h2>
              <p style={estilos.subtitulo}>Escribe tu nueva contraseña.</p>
              {error && <div style={estilos.error}>{error}</div>}
              {sesionLista && (
                <form onSubmit={handleReset} style={{ width: '100%' }}>
                  <div style={estilos.campo}>
                    <label style={estilos.label}>Nueva contraseña</label>
                    <div style={{ position: 'relative', width: '100%' }}>
                      <input type={verPassword ? 'text' : 'password'} value={password}
                        onChange={e => setPassword(e.target.value)}
                        style={{...estilos.input, paddingRight: '40px'}}
                        placeholder="Mínimo 8 caracteres" required />
                      <button type="button" onClick={() => setVerPassword(!verPassword)}
                        style={{ position: 'absolute', right: '12px', top: '50%',
                        transform: 'translateY(-50%)', background: 'none', border: 'none',
                        cursor: 'pointer', color: '#8B6F47' }}>
                        {verPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>
                  </div>
                  <div style={estilos.campo}>
                    <label style={estilos.label}>Confirmar contraseña</label>
                    <div style={{ position: 'relative', width: '100%' }}>
                      <input type={verConfirm ? 'text' : 'password'} value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                        style={{...estilos.input, paddingRight: '40px'}}
                        placeholder="Repite la contraseña" required />
                      <button type="button" onClick={() => setVerConfirm(!verConfirm)}
                        style={{ position: 'absolute', right: '12px', top: '50%',
                        transform: 'translateY(-50%)', background: 'none', border: 'none',
                        cursor: 'pointer', color: '#8B6F47' }}>
                        {verConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>
                  </div>
                  <button type="submit" disabled={cargando}
                    style={{ ...estilos.btn, opacity: cargando ? 0.7 : 1 }}>
                    {cargando ? 'Guardando...' : 'Guardar nueva contraseña'}
                  </button>
                </form>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

const estilos = {
  pagina: { minHeight: '100vh', backgroundColor: '#FAF8F5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' },
  contenido: { width: '100%', maxWidth: '420px' },
  caja: { backgroundColor: '#FFFFFF', borderRadius: '16px', padding: '40px', border: '1px solid #E8E0D5', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  logo: { width: '80px', height: '80px', objectFit: 'contain', borderRadius: '50%', marginBottom: '16px' },
  titulo: { fontSize: '22px', fontWeight: '700', color: '#2C1810', marginBottom: '8px', textAlign: 'center' },
  subtitulo: { fontSize: '14px', color: '#8B6F47', marginBottom: '24px', textAlign: 'center' },
  campo: { marginBottom: '16px', width: '100%' },
  label: { display: 'block', fontSize: '14px', fontWeight: '600', color: '#2C1810', marginBottom: '6px' },
  input: { width: '100%', padding: '12px 14px', borderRadius: '8px', border: '1px solid #E8E0D5', fontSize: '15px', outline: 'none', backgroundColor: '#FAF8F5', color: '#2C1810' },
  btn: { width: '100%', padding: '13px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', marginTop: '4px' },
  error: { backgroundColor: '#FDF0EC', color: '#8B2E0F', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', border: '1px solid #F5C9B8', width: '100%' },
}

export default ResetPassword
